export const checkinList = {
  group: {
    sectionTitle: "Zugehörige Check-ins",
    registrationForm: "Meldeschein",
    registrationFormHint: "Ein einziges Dokument mit dem Hauptgast und seinen Begleitern",
    registrationFormEmpty: "Für diese Buchung wurde noch kein Check-in abgeschlossen.",
    registrationFormError: "Der Meldeschein konnte nicht erstellt werden. Bitte erneut versuchen.",
    emptyState: "Keine zugehörigen Check-ins.",
    name: "Name",
    phone: "Telefon",
    document: "Dokument",
    notAvailable: "Nicht verfügbar",
    syncSent: "An die Behörden übermittelt",
    syncError: "Fehler bei den Behörden",
    syncPending: "Übermittlung ausstehend",
    moreInfo: "Weitere Informationen",
    email: "E-Mail",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Dokumentart",
    supportNumber: "Trägernummer",
    identityVerification: "Identitätsprüfung",
    tapToEnlarge: "Zum Vergrößern tippen",
    view: "Ansehen",
    download: "Herunterladen",
    selfie: "Selfie",
    minorData: "Daten des Minderjährigen",
    relationship: "Verwandtschaftsverhältnis:",
    noPhotos: "Keine Fotos angehängt.",
    minorDocument: "Dokument des Minderjährigen",
    authorization: "Einverständniserklärung",
    minorAuthorization: "Einverständniserklärung für den Minderjährigen",
    specification: "Angabe:",
    additionalInfo: "Zusätzliche Informationen",
    nationality: "Staatsangehörigkeit",
    birthDate: "Geburtsdatum",
    ageYears: "({age} Jahre)",
    gender: "Geschlecht",
    female: "Weiblich",
    male: "Männlich",
    countryResidence: "Wohnsitzland",
    cityResidence: "Wohnort",
    address: "Adresse",
    zipCode: "Postleitzahl",
    sesBatchId: "SES-Stapelnummer",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "Geburtsland",
    docIssuePlace: "Ausstellungsort des Dokuments",
    signedDocument: "Unterschriebenes Dokument",
    edit: "Bearbeiten",
    remove: "Löschen",
    previewAlt: "Vorschau",
    previewFallbackTitle: "Bild",
    docTypes: {
      passport: "Reisepass",
      passportOrdinary: "Gewöhnlicher Reisepass",
      passportService: "Dienstpass",
      passportDiplomatic: "Diplomatenpass",
      idCard: "Ausweisdokument",
      nie: "NIE",
      idCardElectronic: "Elektronisches Ausweisdokument",
      idDiplomatic: "Diplomatisches Ausweisdokument",
      citizenshipCard: "Bürgerausweis",
      foreignerCard: "Ausländerausweis",
      drivingLicense: "Führerschein",
      nauticalLicense: "Bootsführerschein",
      specialResidencePermit: "Besondere Aufenthaltserlaubnis",
      foreignerDocument: "Ausländerdokument",
      foreignDocument: "Ausländisches Dokument",
      diplomaticCard: "Diplomatenausweis",
      refugeeTravelDocument: "Reiseausweis für Flüchtlinge",
      otherDocument: "Anderes Dokument",
    },
  },
  individual: {
    title: "Gastdaten",
    phone: "Telefon",
    email: "E-Mail",
    notAvailable: "Nicht verfügbar",
    lodging: "Aufenthalt",
    docType: "Dokumentart",
    docNumber: "Dokumentnummer",
    supportNumber: "Trägernummer",
    identityVerification: "Identitätsprüfung",
    document: "Dokument",
    tapToEnlarge: "Zum Vergrößern tippen",
    view: "Ansehen",
    download: "Herunterladen",
    selfie: "Selfie",
    minorData: "Daten des Minderjährigen",
    relationship: "Verwandtschaftsverhältnis:",
    noPhotos: "Keine Fotos angehängt.",
    minorDocument: "Dokument des Minderjährigen",
    authorization: "Einverständniserklärung",
    minorAuthorization: "Einverständniserklärung für den Minderjährigen",
    specification: "Angabe:",
    additionalInfo: "Zusätzliche Informationen",
    nationality: "Staatsangehörigkeit",
    birthDate: "Geburtsdatum",
    ageYears: "({age} Jahre)",
    gender: "Geschlecht",
    female: "Weiblich",
    male: "Männlich",
    countryResidence: "Wohnsitzland",
    cityResidence: "Wohnort",
    address: "Adresse",
    zipCode: "Postleitzahl",
    sesBatchId: "SES-Stapelnummer",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "Geburtsland",
    docIssuePlace: "Ausstellungsort des Dokuments",
    signedDocument: "Unterschriebenes Dokument",
    edit: "Bearbeiten",
    previewAlt: "Vorschau",
    previewFallbackTitle: "Bild",
    docTypes: {
      passport: "Reisepass",
      passportOrdinary: "Gewöhnlicher Reisepass",
      passportService: "Dienstpass",
      passportDiplomatic: "Diplomatenpass",
      idCard: "Ausweisdokument",
      nie: "NIE",
      idCardElectronic: "Elektronisches Ausweisdokument",
      idDiplomatic: "Diplomatisches Ausweisdokument",
      citizenshipCard: "Bürgerausweis",
      foreignerCard: "Ausländerausweis",
      drivingLicense: "Führerschein",
      nauticalLicense: "Bootsführerschein",
      specialResidencePermit: "Besondere Aufenthaltserlaubnis",
      foreignerDocument: "Ausländerdokument",
      foreignDocument: "Ausländisches Dokument",
      diplomaticCard: "Diplomatenausweis",
      refugeeTravelDocument: "Reiseausweis für Flüchtlinge",
      otherDocument: "Anderes Dokument",
    },
  },
};
